import 'bootstrap/dist/css/bootstrap.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import "./i18nextConf";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <Suspense fallback="loading">
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </Suspense>,
    rootElement);

registerServiceWorker();
